/* eslint-disable import/no-cycle */
import React, { useEffect, useState } from "react";
import {
  CityProps,
  StateProps,
} from "../../../../../domain/models/address.model";
import { DeveloperCompanyModel } from "../../../../../domain/models/developer-company.model";
import { FilterModel } from "../../../../../domain/models/enum";
import { TakerModel } from "../../../../../domain/models/taker";
import { makeRemoteAddresss } from "../../../../../main/factories/usecases/address-controller/remote-address-controller-factory";
import ButtonComponent from "../../../../components/button";
import ButtonRound from "../../../../components/button-action";
import { ItemField } from "../../../../components/datagrid";
import { GroupProp } from "../../../../components/form-factory/utils/util";
import Icons from "../../../../components/icons-helper";
import { theme } from "../../../../styles/theme";
import { ContainerButtonActions } from "./styles";
import { NFSeTypeEnum, NFSeTypeList } from "../../../../enums/nfs-e-type.enum";
import { FiscalNoteModel } from "../../../../../domain/models/fiscal-note";
import TomadorComponent from "../../issue/form/tomador";
import { NationalServiceModel } from "../../../../../domain/models/national-service";
import { NbsModel } from "../../../../../domain/models/nbs";
import { makeRemoteNationalService } from "../../../../../main/factories/usecases/national-service/remote-national-service-factory";
import { makeRemoteNbs } from "../../../../../main/factories/usecases/nbs/remote-nbs-factory";
import { makeRemoteIss } from "../../../../../main/factories/usecases/iss/remote-iss-factory";
import { getIssAliquot } from "../../issue/form/utils/iss";
import { formatNationalTaxCode } from "../../../../../utils/tax";
import HelperMask from "../../../../helpers/helper-mask";
import { requiresObra, TIPO_LOGRADOURO_OPTIONS } from "../../issue/form/constants";

export const FilterFields = (setParams: any): GroupProp[] => {
  const [values, setValues] = useState<string>("");
  return [
    {
      groupName: "FILTER",
      // groupLabel: 'Tomador:',
      items: [
        {
          name: "socialReason",
          type: "text",
          label: "Nome:",
          onChange: (e) => {
            setValues(e);
          },
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "tomadorSearch",
          type: "component",
          component: (): JSX.Element => (
            <div style={{ marginTop: "20px" }}>
              <ButtonComponent
                type="button"
                title="Pesquisar"
                color={theme.colors.white}
                backgroundColor={theme.colors.primary}
                onClick={() =>
                  setParams((prev: FilterModel) => ({
                    ...prev,
                    filters: `socialReason~${values}`,
                  }))
                }
              />
            </div>
          ),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "tomadorClear",
          type: "component",
          component: (): JSX.Element => (
            <div style={{ marginTop: "20px" }}>
              <ButtonComponent
                type="button"
                title="Limpar"
                color={theme.colors.white}
                backgroundColor={theme.colors.primary}
                onClick={() =>
                  setParams((prev: FilterModel) => ({ ...prev, filters: null }))
                }
              />
            </div>
          ),
          col: {
            xs: 2,
            md: 2,
            lg: 2,
          },
        },
      ],
    },
  ];
};
export const Fields = (
  fiscalNote: FiscalNoteModel,
  developerCompaniesList: DeveloperCompanyModel[],
  currentNote: any,
  setCurrentNote: any,
  isToCreate: boolean,
  setIsLoadingNote?: any,
): GroupProp[] => {
  const [companySelected, setCompanySelected] = useState<number>();
  const [aliquotIssRequired, setAliquotIssRequired] = useState<boolean>();
  const [iss, setIss] = useState<boolean>(false);

  const [nationalServices, setNationalServices] = useState<NationalServiceModel[]>([]);
  const [loadingNationalServices, setLoadingNationalServices] = useState<boolean>(false);
  const [nbsList, setNbsList] = useState<NbsModel[]>([]);
  const [loadingNbs, setLoadingNbs] = useState<boolean>(false);
  const [fetchedAliquot, setFetchedAliquot] = useState<string>("0");
  const [showObra, setShowObra] = useState<boolean>(false);
  const [obraTipo, setObraTipo] = useState<string>("");

  const canEditCompany = !!isToCreate;

  const selectedCompany = developerCompaniesList.find(
    (item) => item.id === companySelected,
  );

  const loadNationalServices = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      try {
        setLoadingNationalServices(true);
        const response = await makeRemoteNationalService().loadByCnae(initial);
        setNationalServices(response);
      } catch (error) {
        setNationalServices([]);
      } finally {
        setLoadingNationalServices(false);
      }
    })();
  };

  const loadNbs = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      try {
        setLoadingNbs(true);
        const response = await makeRemoteNbs().loadByLc116(initial);
        setNbsList(response);
      } catch (error) {
        setNbsList([]);
      } finally {
        setLoadingNbs(false);
      }
    })();
  };

  const loadIssCalculate = (nationalServiceId: number): void => {
    (async () => {
      if (!selectedCompany?.company?.id || !nationalServiceId) return;
      try {
        const response = await makeRemoteIss().calculate(selectedCompany.company.id, nationalServiceId);
        setFetchedAliquot(response.aliquot.toString().replace(".", ","));
      } catch (error) {
        setFetchedAliquot("0");
      }
    })();
  };

  const service = fiscalNote && fiscalNote.serviceList && fiscalNote?.serviceList.length > 0 ? fiscalNote?.serviceList[0] : undefined;


  const data = {
    // FilterFields
    socialReason: "",

    // Fields - Main form
    nfseType: "",
    company: fiscalNote?.developerCompany?.id || "",
    competencia: fiscalNote?.competencia ? new Date(fiscalNote?.competencia).toISOString().split("T")[0] : "",
    emissionDate: new Date().toISOString().split("T")[0],
    description: fiscalNote?.observation?.replace(/\|/g, "\n") || "",
    cnae: service?.cnae?.id || "",
    nationalService: service?.nationalService?.id || "",
    nbs: service?.nbs?.id || "",
    serviceValue: fiscalNote?.noteValue?.toString() || "",
    unconditionalDiscount: service?.unconditionalDiscount || "",
    conditionedDiscount: service?.conditionedDiscount || "",
    dedution: service?.otherDeductions || "",
    totalValue: "",
    iss: service?.issRetained ? "true" : "false",
    issAliquot: service?.issAliquot || "",
    otherDeductions: "",
    hasRecurrence: "true",
    dayOfRecurrence: fiscalNote.dayOfRecurrence || "",
    tomador: fiscalNote.taker?.socialReason || "",

    // FieldsTomador
    documentTypeEnum: "",
    documentNumber: "",
    municipalRegistration: "",
    stateRegistration: "",
    zipCode: "",
    address: "",
    number: "",
    district: "",
    complement: "",
    email: "",
    taxSubstitute: "",

    // FieldsCNAES
    code: "",
    codeActivity: "",
    descriptionActivity: "",
    aliquot: ""
  };

  useEffect(() => {
    if (currentNote) {
      if (currentNote.company) {
        setCompanySelected(currentNote.company);
        const comp = developerCompaniesList.find((c) => c.id === currentNote.company);
        if (comp) {
          setAliquotIssRequired(comp.company?.simpleNacional);
        }
      }
      if (currentNote.cnae) {
        loadNationalServices(currentNote.cnae);
      }
      if (currentNote.iss) {
        setIss(currentNote.iss === "true");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentNote?.id, currentNote?.company, currentNote?.cnae, developerCompaniesList.length]);

  useEffect(() => {
    if (currentNote?.nationalService && nationalServices.length > 0) {
      const ns = nationalServices.find((n) => n.id === currentNote.nationalService);
      if (ns) {
        loadNbs(ns.complementaryLawId);
        loadIssCalculate(currentNote.nationalService);
        setShowObra(requiresObra(ns.nationalTaxCode));
        if (currentNote.obraTipo) {
          setObraTipo(currentNote.obraTipo);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nationalServices.length, currentNote?.nationalService, selectedCompany?.id]);

  useEffect(() => {
    if (setIsLoadingNote && currentNote) {
      const isCompanyReady = !!developerCompaniesList.find((c) => c.id === currentNote.company) || !currentNote.company;
      const isNationalServiceReady = (nationalServices.length > 0 && nationalServices.some((ns) => ns.id === currentNote.nationalService)) || !currentNote.nationalService;
      const isNbsReady = (nbsList.length > 0 && nbsList.some((n) => n.id === currentNote.nbs)) || !currentNote.nbs;

      // When everything in the chain is resolved
      if (isCompanyReady && isNationalServiceReady && isNbsReady) {
        setIsLoadingNote(false);
      }
    }
  }, [currentNote, developerCompaniesList, nationalServices, nbsList, setIsLoadingNote]);


  // Removed state and city loading logic as per issue form changes

  return [
    {
      groupName: "RECURRENCE",
      groupLabel: "Data da primeira nota:",
      items: [
        {
          name: "dayOfRecurrence",
          type: "date",
          label: "Data da primeira nota*:",
          placeholder: "Selecione a data da primeira nota",
          validations: "dateFromToday",
          initialValue: data.dayOfRecurrence,
          needsTooltip: true,
          tooltip: "As notas dos meses subsequente, serão emitidas no mesmo dia da primeira nota",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "TOMADOR",
      groupLabel: "Prestador:",
      items: [
        {
          name: "company",
          type: "select",
          validations: "inputRequired",
          label: "Selecione a empresa que prestou o serviço*:",
          filter: true,
          initialValue: data.company,
          defaultValue: data.company,
          disabled: !canEditCompany,
          onChange: (e: any) => {
            setCompanySelected(e.value);
          },
          options: developerCompaniesList?.map((el) => ({
            value: el?.id,
            label: `${HelperMask.applyCnpjMask(el.company?.subscriptionNumber || "")} — ${el.company?.socialReason}`,
            rawCnpj: (el.company?.subscriptionNumber || "").replace(/\D/g, ""),
          })),
          filterBy: "label,rawCnpj",
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
      ],
    },
    {
      groupName: "TOMADOR",
      groupLabel: "Tipo de Nota Fiscal:",
      items: [
        {
          name: "nfseType",
          type: "select",
          validations: "inputRequired",
          label: "Tipo de nota fiscal eletrônica:",
          options: NFSeTypeList,
          defaultValue: NFSeTypeEnum.NFS_E_NACIONAL,
          disabled: true,
          initialValue: data ? data.nfseType : NFSeTypeEnum.NFS_E_NACIONAL,
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
      ],
    },
    {
      groupName: "TOMADOR",
      groupLabel: "Tomador:",
      items: [
        {
          name: "tomador",
          type: "component",
          component: (): JSX.Element => (
            <TomadorComponent
              setCurrentNote={setCurrentNote}
              currentNote={currentNote}
              selectedDeveloperId={selectedCompany?.developer?.id}
            />
          ),
        },
      ],
    },
    {
      groupName: "SERVICE",
      groupLabel: "Dados do Serviço:",
      items: [
        {
          name: "description",
          type: "textarea",
          label: "Discriminação do(s) serviço(s) prestado(s)*:",
          validations: "inputRequired",
          initialValue: data?.description,
          rows: 6,
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "cnae",
          type: "select",
          label: "Atividade Econômica do Prestador(CNAE)*:",
          tooltip: "As atividades listadas baseiam-se no seu CNPJ. Caso a lista esteja incompleta, você pode atualizá-la em seu perfil recarregando os dados da empresa.",
          needsTooltip: true,
          validations: "inputRequired",
          placeholder: "00000 - Exemplo",
          onChange: (e: any) => {
            const selected = selectedCompany?.company?.cnaes?.find((el) => el.id === e.value);
            setCurrentNote((prev: any) => ({
              ...prev,
              cnae: e.value,
              nationalService: undefined,
              nbs: undefined,
              cnaeLabel: selected ? `${selected.codeFormatted} - ${selected.description}` : "",
            }));
          },
          filter: true,
          initialValue: currentNote?.cnae?.id || currentNote?.cnae,
          options: selectedCompany?.company?.cnaes?.map((el) => ({
            ...el,
            value: el?.id,
            label: `${el?.codeFormatted} - ${el.description}`,
          })),
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "nationalService",
          type: "select",
          label: "Serviço Nacional*:",
          placeholder: "Selecione o serviço nacional",
          loading: loadingNationalServices,
          disabled: loadingNationalServices,
          initialValue: currentNote?.nationalService?.id || currentNote?.nationalService,
          onChange: (e: any) => {
            const selected = nationalServices.find((ns) => ns.id === e.value);
            if (selected) {
              setCurrentNote((prev: any) => ({
                ...prev,
                nationalService: e.value,
                nbs: undefined,
                nationalServiceLabel: `${formatNationalTaxCode(selected.nationalTaxCode)} - ${selected.description}`,
              }));
              setShowObra(requiresObra(selected.nationalTaxCode));
              if (!requiresObra(selected.nationalTaxCode)) {
                setObraTipo("");
              }
            }
          },
          options: nationalServices.map((el) => ({
            value: el?.id,
            label: `${formatNationalTaxCode(el?.nationalTaxCode)} - ${el?.description}`,
          })),
          filter: true,
          validations: "inputRequired",
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "nbs",
          type: "select",
          label: "NBS*:",
          placeholder: "Selecione o NBS",
          loading: loadingNbs,
          disabled: loadingNbs,
          initialValue: currentNote?.nbs?.id || currentNote?.nbs,
          options: nbsList.map((el) => ({
            value: el?.id,
            label: `${el?.codigoNbs} - ${el?.description}`,
          })),
          onChange: (e: any) => {
            const selected = nbsList.find((ns) => ns.id === e.value);
            if (selected) {
              setCurrentNote((prev: any) => ({
                ...prev,
                nbs: e.value,
                nbsLabel: `${selected.codigoNbs} - ${selected.description}`,
              }));
            }
          },
          filter: true,
          validations: "inputRequired",
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
      ],
    },
    ...(showObra ? [{
      groupName: "OBRA",
      groupLabel: "Dados da Obra (Construção Civil):",
      items: [
        {
          name: "obraTipo",
          type: "select",
          label: "Tipo de Identificação da Obra*:",
          validations: "inputRequired",
          initialValue: currentNote?.obraTipo || "",
          onChange: (e: any) => {
            setObraTipo(e.value);
            setCurrentNote((prev: any) => ({ ...prev, obraTipo: e.value }));
          },
          options: [
            { value: "CODIGO", label: "Código da Obra (CEI/CNO)" },
            { value: "ENDERECO", label: "Endereço da Obra" },
          ],
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        {
          name: "obraInscricaoImobFisc",
          type: "text",
          label: "Inscrição Imobiliária Fiscal:",
          initialValue: currentNote?.obraInscricaoImobFisc || "",
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        ...(obraTipo === "CODIGO" ? [
          {
            name: "obraCodigo",
            type: "text",
            label: "Código da Obra (CEI/CNO)*:",
            validations: "inputRequired",
            initialValue: currentNote?.obraCodigo || "",
            col: {
              xs: 12,
              md: 12,
              lg: 12,
            },
          },
        ] : []),
        ...(obraTipo === "ENDERECO" ? [
          {
            name: "obraAddress.tipoLogradouro",
            type: "select",
            label: "Tipo de Logradouro*:",
            validations: "inputRequired",
            initialValue: currentNote?.obraAddress?.tipoLogradouro || "",
            options: TIPO_LOGRADOURO_OPTIONS,
            col: {
              xs: 4,
              md: 4,
              lg: 4,
            },
          },
          {
            name: "obraAddress.place",
            type: "text",
            label: "Endereço*:",
            validations: "inputRequired",
            initialValue: currentNote?.obraAddress?.place || "",
            col: {
              xs: 8,
              md: 8,
              lg: 8,
            },
          },
          {
            name: "obraAddress.number",
            type: "text",
            label: "Número*:",
            validations: "inputRequired",
            initialValue: currentNote?.obraAddress?.number || "",
            col: {
              xs: 4,
              md: 4,
              lg: 4,
            },
          },
          {
            name: "obraAddress.district",
            type: "text",
            label: "Bairro*:",
            validations: "inputRequired",
            initialValue: currentNote?.obraAddress?.district || "",
            col: {
              xs: 4,
              md: 4,
              lg: 4,
            },
          },
          {
            name: "obraAddress.complement",
            type: "text",
            label: "Complemento:",
            initialValue: currentNote?.obraAddress?.complement || "",
            col: {
              xs: 4,
              md: 4,
              lg: 4,
            },
          },
          {
            name: "obraAddress.city",
            type: "text",
            label: "Cidade*:",
            validations: "inputRequired",
            initialValue: currentNote?.obraAddress?.city || "",
            col: {
              xs: 4,
              md: 4,
              lg: 4,
            },
          },
          {
            name: "obraAddress.state",
            type: "text",
            label: "UF*:",
            validations: "inputRequired",
            initialValue: currentNote?.obraAddress?.state || "",
            col: {
              xs: 4,
              md: 4,
              lg: 4,
            },
          },
          {
            name: "obraAddress.zipCode",
            type: "text",
            label: "CEP*:",
            mask: "00000-000",
            validations: "inputRequired",
            initialValue: currentNote?.obraAddress?.zipCode || "",
            col: {
              xs: 4,
              md: 4,
              lg: 4,
            },
          },
        ] : []),
      ] as any[],
    }] : []),
    {
      groupName: "VALUES",
      groupLabel: "Valores:",
      items: [
        {
          name: "serviceValue",
          type: "currency",
          label: "Valor do(s) serviço(s)*:",
          placeholder: "0,00",
          validations: "inputRequired",
          initialValue: data.serviceValue,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "unconditionalDiscount",
          type: "currency",
          label: "Desconto Incondicionado:",
          initialValue: data.unconditionalDiscount,
          placeholder: "0,00",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "conditionedDiscount",
          type: "currency",
          label: "Desconto Condicionado:",
          initialValue: data.conditionedDiscount,
          placeholder: "0,00",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "dedution",
          type: "currency",
          disabled: true,
          label: "Valor das deduções*:",
          initialValue: data.dedution,
          placeholder: "0,00",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },

        {
          name: "totalValue",
          type: "currency",
          initialValue: data.totalValue,
          label: "Valor da Nota:",
          placeholder: "0,00",
          disabled: true,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "iss",
          type: "radio",
          label: "ISS Retido*:",
          onChange(val) {
            const company = developerCompaniesList.find(
              (item) => item.id === companySelected,
            );
            setAliquotIssRequired(company?.company?.simpleNacional);
            setIss(val === "true");
          },
          options: [
            { value: "true", label: "Sim" },
            { value: "false", label: "Não" },
          ],
          validations: "inputRequired",
          initialValue: data.iss,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "issAliquot",
          type: "currency",
          defaultValue: getIssAliquot(iss, fetchedAliquot, currentNote?.issAliquot || data.issAliquot || "0"),
          disabled: !iss,
          onChange: (val: any) => {
            setCurrentNote((prev: any) => ({ ...prev, issAliquot: val }));
          },
          initialValue: data.issAliquot,
          label: "Alíquota:",
          placeholder: "0,00",
          validations: iss && aliquotIssRequired ? "inputRequired" : "",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "otherDeductions",
          type: "currency",
          label: "Outras deduções:",
          initialValue: data.otherDeductions,
          placeholder: "0,00",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
  ];
};

export const FieldsTomador = (
  data: TakerModel | null | undefined,
): GroupProp[] => {
  const [stateList, setStatesList] = useState<StateProps[]>([]);
  const [citiesList, setCitiesList] = useState<CityProps[]>([]);
  const [docType, setDocType] = useState<"CNPJ" | "CPF">("CPF");

  const loadCities = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      const citiesData = await makeRemoteAddresss().loadCities(initial);
      setCitiesList(citiesData);
    })();
  };

  useEffect(() => {
    const defaultState = data?.address?.city?.state?.id;
    if (defaultState) {
      loadCities(defaultState);
    }

    (async () => {
      const statesData = await makeRemoteAddresss().loadStates();
      setStatesList(statesData);
    })();
  }, [data]);

  return [
    {
      groupName: "TOMADOR",
      groupLabel: "Tomador:",
      items: [
        {
          name: "documentTypeEnum",
          type: "radio",
          defaultValue: data?.documentTypeEnum || "CPF",
          label: "Documento*",
          onChange: (e) => {
            setDocType(e);
          },
          options: [
            { value: "CPF", label: "CPF" },
            { value: "CNPJ", label: "CNPJ" },
            { value: "NONE", label: "Não Existe" },
          ],
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "documentNumber",
          type: "text",
          label: "CPF/CNPJ:",
          defaultValue: data?.documentNumber,
          placeholder:
            docType === "CPF" ? "000.000.000-00" : "SS. SSS. SSS/SSSS-00",
          mask: docType === "CPF" ? "000.000.000-00" : "SS. SSS. SSS/SSSS-00",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "municipalRegistration",
          type: "text",
          label: "Inscrição Municipal:",
          defaultValue: data?.municipalRegistration,
          placeholder: "",
          // validations: 'inputRequired',
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        {
          name: "stateRegistration",
          type: "text",
          label: "Inscrição Estadual:",
          defaultValue: data?.stateRegistration,
          placeholder: "",
          // validations: 'inputRequired',
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        {
          name: "socialReason",
          type: "text",
          label: "Razão Social/Nome*:",
          defaultValue: data?.socialReason,
          placeholder: "0000000000000000000000",
          validations: "inputRequired",
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "zipCode",
          type: "text",
          label: "CEP:",
          mask: "00000-000",
          validations: "inputRequired",
          defaultValue: data?.address?.zipCode,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        // {
        //   name: 'addressType',
        //   type: 'select',
        //   validations: 'objectRequired',
        //   label: 'Tipo de Endereço:',
        //   defaultValue: Number(addressTypeList?.find(
        //     (el) => el.ENUM === data?.address?.addressType,
        //   )?.value),
        //   options: addressTypeList,
        //   col: {
        //     xs: 4,
        //     md: 4,
        //     lg: 4,
        //   },
        // },
        {
          name: "address",
          type: "text",
          label: "Endereço",
          validations: "inputRequired",
          defaultValue: data?.address?.place,
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },
        {
          name: "number",
          type: "text",
          label: "Número:",
          validations: "inputRequired",
          defaultValue: data?.address?.number,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "district",
          type: "text",
          label: "Bairro:",
          validations: "inputRequired",
          defaultValue: data?.address?.district,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "complement",
          type: "text",
          label: "Complemento:",
          defaultValue: data?.address?.complement,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "state",
          type: "select",
          label: "Estado:",
          validations: "objectRequired",
          defaultValue: data?.address?.city?.state?.id,
          onChange: (e: any) => {
            loadCities(e.value);
          },
          options: stateList.map((el) => ({ value: el?.id, label: el.name })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "city",
          type: "select",
          label: "Cidade:",
          validations: "objectRequired",
          options: citiesList?.map((el) => ({ value: el?.id, label: el.name })),
          defaultValue: data?.address?.city?.id,
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "email",
          type: "text",
          label: "E-mail:",
          validations: "emailRequired",
          defaultValue: data?.email,
          col: {
            xs: 12,
            md: 12,
            lg: 12,
          },
        },
        {
          name: "taxSubstitute",
          type: "radio",
          defaultValue: `${data?.taxSubstitute}`,
          label: "Substituto Tributária*",
          options: [
            { value: "true", label: "Sim" },
            { value: "false", label: "Não" },
          ],
          validations: "inputRequired",
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
      ],
    },
  ];
};
export const FieldsCNAES = (): GroupProp[] => {
  const [stateList, setStatesList] = useState<StateProps[]>([]);
  const [citiesList, setCitiesList] = useState<CityProps[]>([]);

  const loadCities = (initial: number): void => {
    (async () => {
      if (typeof initial !== "number") return;
      const citiesData = await makeRemoteAddresss().loadCities(initial);
      setCitiesList(citiesData);
    })();
  };

  useEffect(() => {
    (async () => {
      const statesData = await makeRemoteAddresss().loadStates();
      setStatesList(statesData);
    })();
  }, []);

  return [
    {
      groupName: "TOMADOR",
      groupLabel: "CNAE:",
      items: [
        {
          name: "code",
          type: "text",
          label: "Código:",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "description",
          type: "text",
          label: "Descrição:",
          validations: "inputRequired",
          col: {
            xs: 8,
            md: 8,
            lg: 8,
          },
        },

        {
          name: "state",
          type: "select",
          label: "Estado:",
          validations: "inputRequired",
          onChange: (e: any) => {
            loadCities(e.value);
          },
          options: stateList.map((el) => ({ value: el?.id, label: el.name })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "city",
          type: "select",
          label: "Cidade:",
          validations: "inputRequired",
          options: citiesList?.map((el) => ({ value: el?.id, label: el.name })),
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
      ],
    },
    {
      groupName: "Activity",
      groupLabel: "Atividade Econômica:",
      items: [
        {
          name: "codeActivity",
          type: "text",
          label: "Código:",
          validations: "inputRequired",
          col: {
            xs: 4,
            md: 4,
            lg: 4,
          },
        },
        {
          name: "descriptionActivity",
          type: "text",
          label: "Descrição:",
          validations: "inputRequired",
          col: {
            xs: 6,
            md: 6,
            lg: 6,
          },
        },
        {
          name: "aliquot",
          type: "number",
          label: "Aliquota:",
          validations: "inputRequired",
          col: {
            xs: 2,
            md: 2,
            lg: 2,
          },
        },
      ],
    },
  ];
};

export const fieldsGrid = (
  setShow: any,
  setShowGrid: any,
  setSelected: any,
): ItemField[] => [
    {
      title: "Documento",
      key: "id",
      renderItem: (data: TakerModel) => data.documentNumber,
    },
    {
      title: "Nome",
      key: "createdAt",
      renderItem: (data: TakerModel) => data.socialReason,
    },
    {
      title: "",
      key: "actions",
      renderItem: (data) => (
        <ContainerButtonActions>
          <ButtonRound
            backgroundColor={theme.colors.white}
            onClick={() => {
              setSelected(data);
              setShowGrid(false);
              setShow(true);
            }}
          >
            <Icons
              height={25}
              width={25}
              name="edit"
              color={theme.colors.primary}
            />
          </ButtonRound>
        </ContainerButtonActions>
      ),
    },
  ];
